import locale from "common/managers/locale";
import DFValidator from "common/validator/DFValidator";
export default {

    _configEditingColumn: function(options, column) {
        if (column.command) {
            if (column.command == "edit" || column.command.name == "edit") {
                if (column.command == "edit") {
                    column.command = {
                        name: "edit"
                    };
                }
                column.command.className = "right editButton";
                column.command.text = {
                    edit: "e",
                    update: locale.get("save"),
                    cancel: locale.get("cancel")
                };
                column.command.template = '<a role="button" class="k-button k-button-icontext #=className#" #=attr# #if(name==="edit"){#tabindex="-1"#}# href="\\#">#if(iconClass){#<span class="#=iconClass#"></span>#}##=text#</a>';
                // If inline editable, the column needs to be wide enough for the save / cancel buttons
                if (options.editable == "inline" || (options.editable && options.editable.mode == "inline")) {
                    column.width = "140px";
                } else {
                    // otherwise, the column only needs to be wide enough for the pencil edit button
                    column.width = "40px";
                }
            } else if (column.command == "destroy" || column.command.name == "destroy") {
                if (column.command == "destroy") {
                    column.command = {
                        name: "destroy"
                    };
                }
                column.command.className = "closeButton";
                column.command.text = "c";
                column.command.attr = {
                    title: locale.get("delete"),
                    alt: locale.get("delete"),
                    tabindex: "-1"
                };
                column.width = "40px";
            }
        }
    },

    /** We change the k-grid-edit class to k-grid-no-edit when the grid is disabled.
     * When disabled, we need to not process click events on these a tags.
     * @param e
     * @private
     */
    _onDisabledEditClick: function(e) {
        if ($(e.target).hasClass("k-grid-no-edit")) {
            e.preventDefault();
        }
    },

    _onEnable: function(value) {
        if (value) {
            var els = this.element.find("tbody>tr:not(.k-detail-row,.k-grouping-row):visible a.k-grid-no-edit");
            els.addClass("k-grid-edit-command");
            els.removeClass("k-grid-no-edit");
        } else {
            var els = this.element.find("tbody>tr:not(.k-detail-row,.k-grouping-row):visible a.k-grid-edit-command");
            els.addClass("k-grid-no-edit");
            els.removeClass("k-grid-edit-command");
        }
    },

    _configEditableCommand: function() {
        this.tbody.find(".k-grid-edit-command").attr("title", locale.get("edit"));
    },

    _configEditing: function(options, element) {
        /** We change the k-grid-edit class to k-grid-no-edit when the grid is disabled.
         When disabled, we need to not process click events on these a tags. **/
        element.bind("click", "a.k-grid-no-edit", $.proxy(this._onDisabledEditClick, this));

        // Add configuration to allow inline editing;
        // If disabling other fields on the screen during editing,
        // listen to the grid for the "dfgrid/edit" and "dfgrid/editDone"
        // events to trigger bindings.
        if (options.editable) {
            if (options.editable == "inline" || options.editable.mode == "inline") {
                if (options.editable == "inline") {
                    options.editable = {
                        mode: "inline",
                        confirmation: false
                    };
                }
                // Apply styles to the editable grid.
                element.addClass("editableGrid");
            }
        }
    },

    /**
     * Check a collapsing group to see if editing needs cancelled.
     * @private
     */
    _cancelEditOnCollapse: function(sel) {
        var collapseUID = $(sel);
        var editingInGroupUID = this.tbody.find("[data-role='editable']").prevUntil(".k-grouping-row").addBack().prev(".k-grouping-row");
        if (editingInGroupUID.length && collapseUID.length && editingInGroupUID[0] == collapseUID[0]) {
            this.cancelRow();
        }
    },

    _prepareEditing: function() {
        var me = this;

        // Cancel changes on sorting, while in edit mode
        if (me.options.editable && me.options.editable == "inline") {
            me.element.find(".k-grid-header .k-link").on('click', function(e) {
                if (me.element.find("tbody").find(".k-grid-edit-row").length) {
                    me.cancelRow();
                    me.trigger("dfgrid/editDone");
                }
            });
        }

        var uid, isSelected, _keepRowSelection = function(grid) {
            if (uid != null && isSelected) {
                setTimeout(function() {
                    var selectedrow = grid.table.find("tr[data-uid='" + uid + "']");
                    selectedrow.toggleClass("k-state-selected", isSelected);
                }, 0);
            }
        };

        me.bind("edit", function(e) {
            if (this.options.editable == "inline" || this.options.editable.mode == "inline") {
                var cnt = e.container;
                var mdl = e.model;

                this.trigger("dfgrid/edit", [
                    cnt,
                    mdl
                ]);
                e.container.find(".k-state-focused").focus();
                e.container.find(".k-grid-cancel-command").addClass("secondary");
                e.container.find(".k-grid-cancel-command, .k-grid-save-command").bind("click", function(e) {
                    var row = $(e.currentTarget).closest("tr");
                    uid = row.data("uid");
                    isSelected = row.hasClass("k-state-selected");
                });
            }

            //Swap out the type of validator used during edit
            var validator = e.container.data("kendoValidator");
            var editable = e.container.data("kendoEditable");
            if (validator && editable) {
                validator.destroy();
                editable.validatable = new DFValidator(e.container, {});
            }
        });
        me.bind("save", function() {
            var grid = this;
            this.dataSource.one("sync", function() {
                grid.trigger("dfgrid/editDone");
                _keepRowSelection(grid);
            });
        });
        me.bind("cancel", function() {
            var grid = this;
            grid.cancelChanges();
            setTimeout(function() {
                grid.refresh();
                _keepRowSelection(grid);
                grid.trigger("dfgrid/editDone");
            }, 0);
        });
    },

    _toggleEditableColumn: function() {
        if (this.options.editable) {
            for (var i = this.columns.length - 1; i >= 0; i--) {
                if (this.columns[i].command && (this.columns[i].command.name === "edit" || this.columns[i].command.name === "destroy")) {
                    if (this.options.readonly) {
                        this.hideColumn(i);
                    } else {
                        this.showColumn(i);
                    }
                }
            }
        }
    }

};
